export enum NavigationMode {
  Undefined,
  Documents,
  LoopNodes,
  Custom
}
